import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c2458a8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./elementResume.scss?vue&type=style&index=0&id=3c2458a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2458a8",
  null
  
)

export default component.exports